export default __webpack_public_path__ + "static/media/car-1.9872db91.png";